import html2canvas from 'html2canvas';
import { useTranslation } from '../../../contexts/TranslationContext';
import { DeviceInfoSection } from './DeviceInfoSection';

type DeviceScreenshotButtonProps = {
  chartRef: React.RefObject<HTMLDivElement>;
};

export function DeviceScreenshotButton({
  chartRef,
}: DeviceScreenshotButtonProps) {
  const { t } = useTranslation();

  const handleDownload = async () => {
    const container = chartRef.current;
    if (!container) return;

    try {
      const canvas = await html2canvas(container, {
        scale: 2, // High resolution
        backgroundColor: '#ffffff',
        logging: false,
        useCORS: true,
      });

      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.download = `chart-${new Date().toISOString()}.png`;
      downloadLink.href = pngFile;
      downloadLink.click();
    } catch (error) {
      console.error('Error generating screenshot:', error);
    }
  };

  return (
    <DeviceInfoSection.Button onClick={handleDownload} color="secondary">
      {t('Download Chart')}
    </DeviceInfoSection.Button>
  );
}
